const WIP = () => {
  return (
    <div className="notification is-warning text-center mt5 is-large">
      This page is a work-in-progress. Please come back later.
    </div>
  );
};

export default WIP;
